<template>
    <div class="session-ratings-wrapper">
        <div class="rating-block flex w-full pb-3" v-for="(d, index) in modifiedRatingData" :key="index">
            <div class="user-avatar md:flex flex-col items-center">
                <Avatar
                :src="baseUrlSrc(d.thumbnail_url)"
                :classStr="'h-12 w-12'"
                />
               
            </div>
            <div class="review-des md:ml-5 ml-2 w-full flex flex-col justify-between mb-2">
                <p class="text-gray-dark text-xs font-medium py-2 capitalize">{{ d.name }}</p>
                 <div class="rating-posted flex flex-row justify-between my-2">
                    <Rating :data="d.rating" />
                    <span
                      class="text-gray-darkest text-xs float-right"
                      v-if="d.created_at"
                    >
                    Posted <span>{{ handleCreatedAt(d.created_at) }}</span>
                    </span>
                </div>
                <div class="review">
                    <p>{{ d.isReadMore && toggleText[index] ? d.body.slice(0, 250) + '...' : d.body }}</p>
                    <span v-if="d.isReadMore" @click="toggleTextHandler(index)" class="text-green-light text-xs cursor-pointer">{{ toggleText[index] ? 'show more' : 'show less' }}</span>
                </div>
               
            </div>
        </div>
        <div
          class="review-load-btn flex justify-center"
          v-if="nextPage && nextPage.length"
        >
            <button
              type="button"
              class="h-10 px-6 py-2 text-sm font-medium tracking-wide capitalize text-white
              transition-colors duration-150 bg-green-light rounded-lg focus:outline-none hover:bg-green-light"
              @click="handleReadMoreReview()"
            >
            Read more 
            </button>
        </div>
    </div>
</template>
<script>
import { Avatar, Rating } from "@/components/t-components";
export default {
    components: {
        Avatar,
        Rating
    },
    props: [
        'ratingData',
        'nextPage',
        'sessionId',
        'handleReadMore'
    ],
    data () {
      return {
        toggleText: []
      }
    },
    methods: {
      handleReadMoreReview () {
        const params = this.nextPage && this.nextPage.substring(this.nextPage.indexOf("?"));
        this.handleReadMore(this.sessionId + params);
      },
      toggleTextHandler (index) {
        this.$set(this.toggleText, index, !this.toggleText[index])
      }
    },
    computed: {
        modifiedRatingData () {
          return this.ratingData && this.ratingData.length && this.ratingData.map((itm, index) => {
            if (itm.body && itm.body.length > 250) {
              itm['isReadMore'] = true
              this.toggleText[index] = this.toggleText[index] == null ? true : this.toggleText[index]
            } else {
              itm['isReadMore'] = false
            }
            return itm
          })
        }
    }
}
</script>
<style scoped>

</style>